module.exports = __webpack_public_path__ + "img/pixy.77dd0f70.jpg";